<template>
    <el-dialog class="approve-dialog" title="提交审批" :close-on-click-modal="false" :visible.sync="visible" width="600px">
        <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px">
            <el-form-item label="分公司" prop="companyList">
                <div class="tag-wrap">
                    <el-tag disable-transitions @close="delCompany(idx)" class="tag-item"
                        v-for="(tag, idx) in formData.companyList" :key="tag.companyCode"
                        :closable="!isSupplier && formData.companyList.length > 1" type="info">
                        {{ tag.companyName }}
                    </el-tag>
                </div>
            </el-form-item>
            <el-form-item label="业务场景" prop="_businessScene">
                <el-input disabled v-model="formData._businessScene"></el-input>
            </el-form-item>
            <el-form-item label="仓储经理" prop="warehouseManagerList">
                <div class="flex">
                    <div class="tag-wrap" style="flex: 1;">
                        <el-tag disable-transitions @close="delApprover(tag)" class="tag-item"
                            v-for="(tag, idx) in formData.warehouseManagerList" :key="tag.mipCode" :closable="enableDel(tag)" type="info">
                            {{ tag.mipName }}/{{tag.mipCode}}
                        </el-tag>
                    </div>
                    <el-button style="margin-left: 10px;" v-if="!isSupplier && formData.warehouseManagerList.length < 5" type="primary"
                        @click="openPersonDialog">选择人员</el-button>
                </div>
            </el-form-item>
            <template v-if="!isSupplier">
                <el-form-item label="分公司总经理" prop="companyManagerCodeName">
                    <el-input disabled v-model="formData.companyManagerCodeName"></el-input>
                </el-form-item>
                <el-form-item label="专司" prop="professionalManagerCodeName">
                    <el-input disabled v-model="formData.professionalManagerCodeName"></el-input>
                </el-form-item>
            </template>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="submit" :loading="btnLoading">提交审批</el-button>
        </span>


        <PersonLimit v-if="showPerDialog" :append-to-body="true" :config="perConfig" :limit="5 - queryUserList.length"
            @closePerDialog="closePerDialog" @confirmPerDialog="confirmPerDialog" @before-close="closePerDialog">
        </PersonLimit>
    </el-dialog>
</template>
<script>
import PersonLimit from '../../../components/personOne/PersonLimit.vue'
import { queryApproval, supplierWarehouseWorkerSalaryConfirmAudit } from '../../../api/warehouseResourceManagement/loaderSalaryConfirm.js'

export default {
    components: { PersonLimit },
    data() {
        var validateApprover = (rule, value, callback) => {
            if (value.length > 5) {
                callback(new Error('审批人不能超过5人'));
            } else {
                callback();
            }
        };
        var validateCompany = (rule, value, callback) => {
            if (value.length > 5) {
                callback(new Error('分公司不能超过5个'));
            } else {
                callback();
            }
        };
        return {
            showPerDialog: false,
            btnLoading: false,
            perConfig: {
                // 框架人员选择的配置
                title: '添加成员',
                showDialog: false,
                selectList: [],
                value: '',
                tree: {
                    key: 'code',
                    defaultProps: {
                        children: 'children',
                        label: 'name',
                    },
                },
                operation: [
                    {
                        label: '取 消',
                        Event: 'closePerDialog',
                    },
                    {
                        label: '确 定',
                        Event: 'confirmPerDialog',
                        type: 'primary',
                    },
                ],
            },
            rules: {
                companyList: [
                    { required: true, message: '至少保留一个分公司', trigger: 'change' },
                    { validator: validateCompany, trigger: 'change' }
                ],
                warehouseManagerList: [
                    { required: true, message: '至少一个审批人', trigger: 'change' },
                    { validator: validateApprover, trigger: 'change' }
                ],
            },
            visible: false,
            formData: {
                companyList: [],
                warehouseManagerList: [],
                companyManagerList: [],
                professionalManagerList: [],
                companyManagerCodeName: '',
                professionalManagerCodeName: '',
                _businessScene: '',
            },
            selectList: [],
            bonusUserList: [],
            queryUserList: [],
        }
    },
    computed: {
        isSupplier() {
            return !!this.$store.state.supplier
        },
    },
    methods: {
        init(companyList, selectList) {
            this.visible = true
            this.formData = {
                companyList,
                warehouseManagerList: [],
                companyManagerList: [],
                professionalManagerList: [],
                companyManagerCodeName: '',
                professionalManagerCodeName: '',
                //父组件已经卡控了selectList有值并且businessScene相同，这里直接取第一条数据字典转换后的字段即可
                _businessScene: selectList[0]._businessScene,
            }
            this.bonusUserList = []
            this.queryUserList = []
            this.selectList = selectList
            queryApproval(selectList.map(v => v.id))
                .then(res => {
                    if (res && +res.code === 0) {
                        this.queryUserList = res.data.warehouseManagerList || []
                        this.formData.warehouseManagerList = res.data.warehouseManagerList || []
                        this.formData.companyManagerCodeName = (res.data.companyManagerList || []).map(v => `${v.mipName}/${v.mipCode}`) + ''
                        this.formData.professionalManagerList = res.data.professionalManagerList || []
                        this.formData.companyManagerList = res.data.companyManagerList || []
                        this.formData.professionalManagerCodeName = (res.data.professionalManagerList || []).map(v => `${v.mipName}/${v.mipCode}`) + ''
                        this.$nextTick(() => {
                            this.$refs['ruleForm'].clearValidate()
                        })
                    }
                })
        },
        enableDel(item){
            return this.bonusUserList.findIndex(v => v.mipCode === item.mipCode) > -1
        },
        submit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.btnLoading = true
                    supplierWarehouseWorkerSalaryConfirmAudit({
                        confirmCodeList: this.selectList.map(v => v.confirmCode),
                        // companyCodeList: this.formData.companyList.map(v => v.companyCode),
                        // companyNameList: this.formData.companyList.map(v => v.companyName),
                        // approvalCodeList: this.formData.warehouseManagerList.map(v => v.mipCode),
                        // approvalNameList: this.formData.warehouseManagerList.map(v => v.mipName),
                        warehouseManagerList: this.formData.warehouseManagerList,
                        companyManagerList: this.formData.companyManagerList,
                        professionalManagerList: this.formData.professionalManagerList,
                    }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功')
                            this.visible = false
                            this.$emit('refresh')
                        }
                    }).finally(() => {
                        this.btnLoading = false
                    })
                }
            });
        },
        delCompany(idx) {
            this.formData.companyList.splice(idx, 1)
            this.$nextTick(() => {
                this.$refs.ruleForm.validateField('companyList');
            })
            queryApproval(this.selectList.map(v => v.id))
                .then(res => {
                    if (res && +res.code === 0) {
                        this.queryUserList = res.data.warehouseManagerList || []
                        this.formData.warehouseManagerList = [...(res.data.warehouseManagerList || []), ...this.bonusUserList]
                        this.formData.companyManagerCodeName = (res.data.companyManagerList || []).map(v => `${v.mipName}/${v.mipCode}`) + ''
                        this.formData.professionalManagerCodeName = (res.data.professionalManagerList || []).map(v => `${v.mipName}/${v.mipCode}`) + ''
                        this.$nextTick(() => {
                            this.$refs.ruleForm.validateField('warehouseManagerList');
                        })
                    }
                })
        },
        delApprover(item) {
            const approveIdx = this.formData.warehouseManagerList.findIndex(v => item.mipCode === v.mipCode)
            const bonusIdx = this.bonusUserList.findIndex(v => item.mipCode === v.mipCode)
            if (approveIdx > -1) {
                this.formData.warehouseManagerList.splice(approveIdx, 1)
            }
            if (bonusIdx > -1) {
                this.bonusUserList.splice(bonusIdx, 1)
            }
            this.$nextTick(() => {
                this.$refs.ruleForm.validateField('warehouseManagerList');
            })
        },
        // 打开内部人员菜单
        openPersonDialog() {
            this.showPerDialog = true
            this.perConfig.selectList = []
            setTimeout(() => {
                this.perConfig.showDialog = true
                this.perConfig.selectList = [...this.bonusUserList.map(v => ({ userName: v.mipName, userCode: v.mipCode }))]
            }, 100)
        },
        // 保存选择框架人员信息
        confirmPerDialog(data) {
            this.bonusUserList = [...data.selectList.map(v => ({ mipCode: v.userCode, mipName: v.userName }))]
            this.formData.warehouseManagerList = [...this.queryUserList,...this.bonusUserList]
            this.perConfig.showDialog = false
            this.showPerDialog = false
            this.perConfig.selectList = []
            this.$nextTick(() => {
                this.$refs.ruleForm.validateField('warehouseManagerList');
            })
        },
        // 关闭内部人员菜单
        closePerDialog() {
            this.perConfig.showDialog = false
            this.showPerDialog = false
        },
    }
}
</script>
<style lang="less" scoped>
.approve-dialog {
    .flex {
        display: flex;
        align-items: center;
        width: 100%;
    }

    .tag-wrap {
        border: 1px solid #f5f5f5;
        padding: 10px;
        min-height: 40px;
        width: 100%;
        box-sizing: border-box;

        .tag-item {
            margin-right: 10px;
            margin-bottom: 10px;
        }
    }
}
</style>